        <div class="row details">
            <div class="col-sm-12">
                <div *ngIf="errorMsg" class="text-center alert-text">{{errorMsg}}</div>
                
                <div>
                    <div class="item">
                        <label>
                            PARS Individual Learner Report
                        </label>
                        <div class='instructions'>
                            To download a PARS Individual Report select a date range using the form below. The Starting Date must be within the last 2 years.
                        </div>
                        <div class='row report-block'>
                            <form [formGroup]="form" novalidate>
                        
                                <!-- <div class='row form-group' *ngIf="!isLoading"> -->
                                <div class='row form-group'>
                                    <div class='col-xs-3'>
                                        <label>Start Date</label>
                                        <div id="startDate" formControlName="startDate" class="input-group" a2e-datetimepicker [options]="reportsDateOptions">
                                            <input type="text" placeholder="Start Date" class="form-control"/>
                                            <!-- for bootstrap 4 <span class="input-group-text"> -->
                                                <span class="input-group-addon">
                                                    <i class="fa fa-calendar"></i>
                                                </span>
                                            <!-- </span> -->
                                        </div>
                                    </div>
                        
                                    <div class='col-xs-3'>
                                        <label>End Date</label>
                                        <div id="endDate" formControlName="endDate" class="input-group" a2e-datetimepicker [options]="reportsDateOptions">
                                            <input type="text" placeholder="End Date" class="form-control"/>
                                            <!-- for bootstrap 4 <span class="input-group-text"> -->
                                                <span class="input-group-addon">
                                                    <i class="fa fa-calendar"></i>
                                                </span>
                                            <!-- </span> -->
                                        </div>
                                    </div>
                                    <div class='col-xs-3'>
                                        <label>Include License Info</label>
                                        <div id="includeLicense" class="input-group">
                                            <input type="checkbox" formControlName="includeLicense" class="form-control"/>
                                        </div>
                                    </div>
                        
                                    <div class='col-xs-2'>
                                        <label>&nbsp;</label>
                                        <button class="btn btn-default btn-md ng-scope" type="button" (click)="pars_individual_report()"> 
                                            <div class="div-button">Generate</div>
                                        </button>
                                    </div>
                        
                                </div>
                            </form>
                            <div class='col-xs-12' *ngIf="isLoading">
                                <app-loading [isLoading]="isLoading"></app-loading>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>